import { client } from './client'
import type { TenantMember, InviteTenantUserRequest, InviteTenantUserResponse } from '@/types'
import type { PagedResult, PaginationParams } from '@/types'

export interface TenantMineResponse {
  id: string
  name: string
  cloudProvider: string
  status: string
  role: string
}

export const tenantsApi = {
  getMine: () =>
    client.get<TenantMineResponse[]>('/tenants/mine').then(r => r.data),

  getMembers: (tenantId: string, params?: Partial<PaginationParams> & { search?: string; role?: string; status?: string; sortBy?: string; sortDirection?: 'asc' | 'desc' }) =>
    client.get<PagedResult<TenantMember>>(`/tenants/${tenantId}/members`, { params }).then(r => r.data),

  inviteUser: (tenantId: string, data: InviteTenantUserRequest) =>
    client.post<InviteTenantUserResponse>(`/tenants/${tenantId}/members`, data).then(r => r.data),

  removeUser: (tenantId: string, userId: string) =>
    client.delete(`/tenants/${tenantId}/users/${userId}`),
}
